import firebaseApp from "../../firebase/credenciales";
import React from "react";
import { getFirestore, collection, getDocs } from "firebase/firestore";
const db = getFirestore(firebaseApp);

//const {contextData} = useDataContext();
    

export default async function getProductos_cultivo_proceso(valor) {
    

  //console.log(valor);
    const productosDB =  [];
    //console.log(valor);
    const collectionRef = collection(db, "Cultivo_en_proceso/"+valor.nombre+"/Productos".replace(/ /g, ""));
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      productosDB.push(doc.data());
    });
    return productosDB;
    

}


//"+productofolio+"
